import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Chart } from 'chart.js';
import { v4 as uuidv4 } from 'uuid';
import BasicChartData from 'models/basic-chart-data/basic-chart-data.model';

@Component({
  selector: 'app-basic-chart',
  templateUrl: './basic-chart.component.html',
  styleUrls: ['./basic-chart.component.scss'],
})
export class BasicChartComponent implements OnInit {
  @Input() chartDataSubject:  BehaviorSubject<BasicChartData> = new BehaviorSubject(new BasicChartData());
  public chart: any = null;
  public elementId: string = `basicChartCanvas-${uuidv4()}`;
  private currentChart: Chart;

  ngOnInit() {
    this.chartDataSubject.subscribe((data) => {
      setTimeout(() => {
        const options = {
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              },
            }],
          },
        };
        let canvas : any = document.getElementById(this.elementId) as HTMLElement;

        if (this.currentChart) {
          this.currentChart.destroy();
        }
        
        this.currentChart = new Chart(
          canvas,
          {
            type: 'bar',
            data,
            options,
          },
        );
      }, 800);
    });
  }
}
